define(function (require) {
    "use strict";
    var LE = require("app");
    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var LpaView = require("personalization-user-management-views/LpaView");
    var BaseModel = require("models/BaseModel");
    var SiteSettingsModel = require("models/SiteSettingsModel");
    var ProfilesCollection = require("collections/entities/ProfilesCollection");

    var LpaController = {};
    function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {

        LpaController = BaseFeatureController.extend({
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "LpaController:initialize", options);
                this.featureId = options.featureOptions.id;
                this.profilesCollection = new ProfilesCollection();
                this._fetchProfilesCollection();
                this.lpaView = new LpaView({
                    anchorSelector:options.featureOptions.anchorSelector,
                    featureId:this.featureId
                });
                this.listenTo(this.lpaView, "lpa:navigateToFeatureEdit", this._onNavigateToFeatureEdit, this);
            },
            getAnchorView: function (options) {
                LEPersonalization.logger.debug("return this view", "LpaController:getAnchorView", options);
                return this.lpaView;
            },
            _onNavigateToFeatureEdit: function () {
                LEPersonalization.logger.debug("navigates to feature edit controller", "LpaController:_onNavigateToFeatureEdit");
                LEPersonalization.navigateToFeatureEdit({
                    featureId: this.featureId,
                    controllerOptions:{
                        profilesCollection: this.profilesCollection,
                        IsLpaAssigned: this.IsLpaAssigned
                    }
                });
            },

            _fetchProfilesCollection: function(){
                LEPersonalization.logger.debug("call of _fetchProfilesCollection", "LpaController:_fetchProfilesCollection");
                var fetchOptions = {
                    success: _.bind(this._onProfilesFetchSuccess, this),
                    error: _.bind(this._onProfilesFetchError, this)
                };
                this.profilesCollection.fetch(fetchOptions);
            },

            _onProfilesFetchSuccess: function(collection, response, options){
                LEPersonalization.logger.debug("profiles collection fetched successfully", "LpaController:_onProfilesFetchSuccess", response);
                this.IsLpaAssigned = this.profilesCollection.checkIfLpaAssigned();
                this.lpaView.setLpaIsAssigned(this.IsLpaAssigned);
            },

            _onProfilesFetchError: function(collection, response, options){
                LEPersonalization.logger.debug("error when fetching profiles collection", "LpaController:_onProfilesFetchError", response);
                LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
            }

        });
    }

    LE.module("LEPersonalization", moduleDefinition);

    return LpaController;
});
